import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core/';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import ButtonBase from './Buttons/ButtonBase';


export default ({
  title,
  subtitle,
  open,
  handleClose,
  handleAccept,
  textDenyButton,
  textApproveButton,
}) => {
  const smallMobile = useMediaQuery('(max-width: 580px)');
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs">
      <DialogTitle>
        <Typography
          style={{
            color: '#10587f',
            textAlign: 'center',
            fontSize: 22,
            fontWeight: 'bold',
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          style={{
            color: '#484848',
            fontSize: 16,
          }}
        >
          {subtitle}
        </DialogContentText>
        <DialogActions style={{ flexWrap: 'wrap', justifyContent: 'center' }}>
          {handleClose && (
            <ButtonBase
              variant="primary"
              onClick={handleClose}
              style={{ marginBottom: smallMobile? 24 : 0 }}
            >
              {textDenyButton || 'Cancelar'}
            </ButtonBase>
          )}
          <ButtonBase variant="primaryOutlined" onClick={handleAccept}>
            {textApproveButton || 'Si, eliminar'}
          </ButtonBase>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
